//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'
import { get } from 'lodash';
import { useDispatch } from 'react-redux'
import { handlefetchUserProfileConfig , handleupdateserProfileConfig } from './thunks';
import { setHideProfilePickViewer , setShowProfilePickViewer } from "./actions"
import { useMemo } from 'react';

//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const currentUserSelector = (state) => state.currentUser;
const cureentOrgSelecter = (state) => state.currentOrg;
const userCount = (state) => state.allUserCount;
//  -- Examples array selector --------

export const useCurrentUser = () => {
    const selectedData = useSelector(currentUserSelector, shallowEqual)
    return selectedData;
}
export const useDemoStatus = () => {
    const currentUser = useSelector(currentUserSelector, shallowEqual)
    const currentOrg = useSelector(cureentOrgSelecter, shallowEqual)
    const parentOrg = get(currentOrg, "parent", null)
    if(currentUser&&currentUser.role=="owe_admin"){
        return false;
    }
    if (currentUser && currentUser.demo) {
        return true;
    } else if (currentOrg && currentOrg.demo) {
        return true;
    } else if (parentOrg && parentOrg.demo) {
        return true;
    } else {
        return false;
    }

}

export const useAllCount = () => {
    const selectedData = useSelector(userCount, shallowEqual)
    return selectedData;
}
// Removed unused useStudentsList

const allUsersSelector = (state) => state.allUser || [];

export const useAllUsers = () => {
    const selectedData = useSelector(allUsersSelector, shallowEqual);
    return selectedData;
};

const ClassAiConfigEnabled = (state) => state.class_ai_config_enabled;
export const useClassAiConfigEnabled = () => {
    const class_ai_config_enabled = useSelector(ClassAiConfigEnabled, shallowEqual);
    return class_ai_config_enabled;
}

const UserProfileConfig = (state) => state.profile_config;
export const useUserProfileConfig = () => {
    const profile_config = useSelector(UserProfileConfig, shallowEqual);
    const class_ai_config_enabled = useSelector(ClassAiConfigEnabled, shallowEqual);
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    async function fetchUserProfileConfig() {
        if (currentUser) {
            await dispatch(handlefetchUserProfileConfig(currentUser.id))
        }
    }
    async function updateserProfileConfig(config) {
        if (currentUser) {
            return dispatch(handleupdateserProfileConfig(currentUser.id, config))
        }
        return ({ });
    }
    const isAiPermissionEnabled = useMemo(() => {
        if(currentUser.role=="teacher"){
        const p_config = profile_config?.config || {};
        if (typeof p_config?.ai_enabled !== "boolean") return true;
        return p_config?.ai_enabled === true;
        }else if(currentUser.role=="student"){
            return typeof class_ai_config_enabled === "boolean" ? class_ai_config_enabled : true;
        } else {
            return true;
        }
    }, [profile_config, class_ai_config_enabled,currentUser])


    return { profile_config, fetchUserProfileConfig, updateserProfileConfig, isAiPermissionEnabled }
}


const profilePicturePicker = (state) => state.profile_picture_picker;
const allDistrictTeacher = (state) => state.all_district_teacher
export const useProfilePicturePicker = () => {
    const profile_picture_picker = useSelector(profilePicturePicker, shallowEqual);
    const dispatch = useDispatch();
    const showProfilePhotoViewer = () => {
        dispatch(setShowProfilePickViewer())
    }
    const hideProfilePhotoViewer = () => {
        dispatch(setHideProfilePickViewer())
    }
    return { profile_picture_picker, showProfilePhotoViewer, hideProfilePhotoViewer }
}

export const useAllDistrictTeacher = () => {
    const all_district_teacher = useSelector(allDistrictTeacher, shallowEqual);
    return all_district_teacher;
}

export const useUserRole = () => {
    const currentUser = useCurrentUser();
    const role = useMemo(() => {
        return currentUser.role;
    }, [currentUser]);
    const is_teacher = useMemo(() => {
        return role === "teacher";
    }, [role]);
    const is_admin = useMemo(() => {
        return role === "admin";
    }, [role]);
    const is_student = useMemo(() => {
        return role === "student";
    }, [role]);
    const is_parent = useMemo(() => {
        return role === "parent";
    }, [role]);
    const is_super_admin = useMemo(() => {
        return role === "owe_admin";
    }, [role]);
    return { is_teacher, is_admin, is_student, is_parent, is_super_admin, role , currentUser };
}